import React from "react";

import {NavLink} from "react-router-dom";

import '../../../css/styles.css';

export default function NavigationImages(props) {

    return (
      <div className="bottom-navigation-images">

          <div className="responsive left bottom-image-navigations-section">
          {
            props.bottomImageNavigation.map((navigation, index) => (
              <div className="navigation-image-column item">
                <button>
                  <NavLink to= {navigation.target}>
                    <img src={navigation.image} alt={navigation.title} />
                    </NavLink>
                </button>
                <span class="caption">{navigation.title}</span>
              </div>
            ))
           }
          </div>

      </div>
    );

}
